import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LiveChatWidgetComponent } from '../../shared/components/live-chat-widget/live-chat-widget.component';
import { SocketsService } from '../..//services/sockets.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'logibids-main',
  imports: [RouterOutlet, LiveChatWidgetComponent],
  templateUrl: './main.component.html',
  styleUrl: './main.component.scss',
})
export class MainComponent {
  private isBrowser: boolean;
  constructor(
    private _SocketsService: SocketsService,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this._SocketsService.initSocket();
    this.setSw();
  }

  setSw(): void {
    if (this.isBrowser) {
      const token = localStorage['accessToken_sp'];
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      navigator.serviceWorker.ready.then(registration => {
        if (navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller?.postMessage({
            type: 'token',
            tokenData: token,
          });
        }
      });
    }
  }
}
